import React, { Component } from 'react'
import { checkTranslation, imageAddress, sizeConvertor, translate } from '../../../../utils/useful';
import CircularProgress from "../../../useful/CircularProgress";
import MessageStatusView from './MessageStatusView';


class MessageFileBox extends Component {
    state = {
        fileName: "this is document one for"
    }
    render() {
        let data = this.props.data
        // console.log('datais',data)
        return (
            <div style={{ width: 250 }} className={'w-100 d-flex flex-column ' + (this.props.isOtherRef ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                <div className={" " + (this.props.isOtherRef ? 'chatbox-other' : 'chatbox')} style={{ width: 250, paddingBottom: "5px" }}>
                    <div className='flexcb w-100 py-1 px-1' style={{ borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div>
                            <div className='flexc'>
                                {this.props.isOtherRef ? (
                                    <img className='flexcc' style={{ width: 30, height: 30, marginRight: 5, }} src='/assets/icons/doc-black.svg' />
                                ) : (
                                    <img className='flexcc' style={{ width: 30, height: 30, marginRight: 5, }} src='/assets/icons/doc-white.svg' />
                                )}
                                <div className=''>
                                    <p className={"font-size-12 " + (this.props.isOtherRef ? 'chatbox-other-color' : 'chatbox-color')} style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: "160px" }}>{checkTranslation(data.file?.orgName)}</p>
                                    <p className={"font-size-10 " + (this.props.isOtherRef ? 'chatbox-other-color' : 'chatbox-color')}>{translate("messenger.File Size")} {sizeConvertor(data.file?.size)}</p>
                                </div>
                                {(data.tempFile) && (
                                    <div className='flexcc mld-4'>
                                        <CircularProgress size={27} strokeWidth={2} progress={data.precentage} />
                                    </div>
                                )}
                            </div>
                        </div>

                        {(!data.tempFile) && (
                            <a href={imageAddress(data.file)} target={"_blank"}>
                                {this.props.isOtherRef ? (
                                    <img className='flexcc' style={{ width: 20, height: 20, marginRight: 7, cursor: "pointer" }} src='/assets/icons/download-black.svg' />
                                ) : (
                                    <img className='flexcc' style={{ width: 20, height: 20, marginRight: 7, cursor: "pointer" }} src='/assets/icons/download-white.svg' />
                                )}
                            </a>
                        )}


                    </div>
                    {data.text && (
                        <div className={"d-flex " + (this.props.isOtherRef ? 'captionbox-other' : 'captionbox')} style={{ maxWidth: 350, padding: '10px 10px', marginLeft: "5px", marginRight: "5px" }}>
                            {/*filename*/}
                            <p className={"mt-1 " + (this.props.isOtherRef ? '' : ' ')} style={{ color: "#333" }}>{checkTranslation(data.text)}</p>
                        </div>
                    )}
                </div>
                <div className={"w-100 d-flex mt-1 " + (this.props.isOtherRef ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                    <div className="flexc">
                        <p className='mrd-2' style={{ color: "gray", fontSize: 10 }}>{checkTranslation(this.props.time)}</p>
                        {(!this.props.isOtherRef&&!this.props.hideStatus) && (
                            <MessageStatusView status={data.status} colors={this.props.colors} />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default MessageFileBox;